import React, { Component } from 'react';
import { connect } from 'react-redux';
import { loadUnpagedWeeklyProgram, fetchWeeklyProgram, createWeeklyProgram, updateWeeklyProgram, copyWeeklyProgram, deleteWeeklyProgram, validateDelete } from './actions';
import WeeklyProgramSettingsForm, { selector as weeklyProgramFormSelector } from './SettingsForm';
import authUtils from '../../auth/utils';
import queryString from 'query-string';
import { withTranslation } from 'react-i18next';
import Dialog from '../../common/components/Dialog';
import { Button } from 'react-bootstrap';
import RemoteSubmitButton from '../../common/components/formControls/RemoteSubmitButton';
import { fetchTerm } from '../terms/actions';
import { fetchCenter } from '../centers/actions';
import { loadUnpagedGrades } from '../grades/actions';
import { loadUnpagedTeachers } from '../teachers/actions';
import { types } from './modes/common';
import EditWeeklyProgram from './modes/EditWeeklyProgram';
import OneOffProgram, { OneOffProgramMode } from './modes/OneOffProgram';
import CopyWeeklyProgram from './modes/CopyWeeklyProgram';
import AutoEnrolProgram from './modes/AutoEnrolProgram';
import { loadData, filterPrograms } from './modes/common';
import { SubmissionError } from 'redux-form';
import { ConfirmationButton } from '../../common/components/formControls';
import { faCheck } from '@fortawesome/free-solid-svg-icons';

class Details extends Component {

	constructor(props) {
		super(props);
		this.handleSave = this.handleSave.bind(this);
		this.handleCopy = this.handleCopy.bind(this);
		this.handleNewClick = this.handleNewClick.bind(this);
		this.handleDelete = this.handleDelete.bind(this);
		this.handleEditClick = this.handleEditClick.bind(this);
		this.handleClose = this.handleClose.bind(this);
		this.checkDeleteValidation = this.checkDeleteValidation.bind(this);
		this.state = {
			showDialog: false,
			showDeleteWithLessons: false
		};
	}

	componentDidMount() {
		loadData(this.props);
	}

	hideDialog() {
		this.setState({ showDialog: false });
	}

	showDialog(day, weeklyProgram) {
		this.setState({ showDialog: true, weekday: day, weeklyProgram });
	}

	handleSave(values) {
		const { createWeeklyProgram, updateWeeklyProgram, history } = this.props;
		const { weeklyProgram } = this.state;
		const { useTermDefault, useGradeDefault, ...submitValues } = values;

		const onSuccessEvent = () => {
			loadData(this.props);
			this.hideDialog();
		}

		if (weeklyProgram) {
			updateWeeklyProgram(weeklyProgram.id, submitValues, onSuccessEvent);
		} else {
			const { daysOfWeek } = submitValues;
			const daysOfWeekBitwise = daysOfWeek && daysOfWeek
				.map(entry => entry.value)
				.reduce((accumulator, currentValue) => accumulator | currentValue);

			createWeeklyProgram({ ...submitValues, daysOfWeek: daysOfWeekBitwise }, history, onSuccessEvent);
		}
	}

	handleCopy(values) {
		if (values.fromTermId == values.toTermId) {
			const { t } = this.props;
			throw new SubmissionError({
				toTermId: t('WeeklyProgram_SelectAnotherTerm'),
				_error: t('WeeklyProgram_CopyFailed'),
			});
		} else {
			const { copyWeeklyProgram, history } = this.props;
			copyWeeklyProgram(values, () => {
				history.push(`/weeklyProgram/action?type=edit&centerId=${values.centerId}&termId=${values.toTermId}`);
			});
		}
	}

	deleteProgramItem() {
		const { deleteWeeklyProgram } = this.props;
		const { weeklyProgram } = this.state;
		deleteWeeklyProgram(weeklyProgram.id, () => this.hideDialog());
	}

	checkDeleteValidation(result) {
		if (result.hasPastLessons) {
			this.setState({ showDeleteWithLessons: true });
		}
		else {
			this.deleteProgramItem();
		}
	}

	handleDelete() {
		const { validateDelete } = this.props;
		const { weeklyProgram } = this.state;

		validateDelete(weeklyProgram.id, (result) => this.checkDeleteValidation(result));
	}

	handleNewClick(day) {
		this.showDialog(day);
	}

	handleEditClick(day, weeklyProgram) {
		this.showDialog(day, weeklyProgram);
	}

	handleClose() {
		this.hideDialog();
	}

	getSettingsForm() {
		const { centerId, termId, weeklyProgramFormValues, enableTrials, enableMakeUps, ...rest } = this.props;
		const { weeklyProgram } = this.state;
		if (weeklyProgram) {
			return (
				<WeeklyProgramSettingsForm
					onSubmit={this.handleSave}
					onDelete={this.handleDelete}
					initialValues={{ ...weeklyProgram, useTermDefault: !weeklyProgram.themeDescription, useGradeDefault: !weeklyProgram.name }}
					enableTrials={enableTrials}
					enableMakeUps={enableMakeUps}
					{...weeklyProgramFormValues}
					{...rest}
				/>

			);
		}

		let status = 1;
		switch (this.props.type) {
			case types.TRIAL:
				status = 2;
				break;
			case types.SINGLE:
				status = 4;
				break;
			default:
				status = 1;
		}

		const initialValues = {
			centerId,
			termId,
			weekday: this.state.weekday,
			status,
			isDeleted: 0,
			recurrenceType: 0,	// none
			useTermDefault: true,
			useGradeDefault: true
		};

		return <WeeklyProgramSettingsForm
			onSubmit={this.handleSave}
			initialValues={initialValues}
			enableTrials={enableTrials}
			enableMakeUps={enableMakeUps}
			{...weeklyProgramFormValues}
			{...rest}
		/>
	}

	renderDeleteButton() {
		const { t, isReadonly } = this.props;
		return (
			<ConfirmationButton
				onConfirmation={() => this.handleDelete()}
				confirmationTitle={t('WeeklyProgram_DeleteConfirmationTitle')}
				confirmationMessage={t('WeeklyProgram_DeleteConfirmationMessage')}
				displayType={'inline'}
				label={t('Common_Delete')}
				className='mr-0'>
			</ConfirmationButton>
		);
	}

	renderDialogFooter() {
		const { t, isReadonly } = this.props;
		const editMode = !!this.state.weeklyProgram;
		const closeBtn = <Button onClick={this.handleClose} className='mr-0'>{t('Common_Close')}</Button>;
		const deleteBtn = !isReadonly && editMode && this.renderDeleteButton();
		const saveBtn = <RemoteSubmitButton style='success' disabled={isReadonly} formName='weeklyProgram' label={t('Common_Save')} icon={faCheck} />;
		return [closeBtn, deleteBtn, saveBtn];
	}

	dialogConfig() {
		const { t, type } = this.props;
		return {
			header: t('WeeklyProgram_EditLesson'),
			body: this.getSettingsForm(),
			onHide: () => this.hideDialog(),
			footer: this.renderDialogFooter()
		};
	}

	dialogDeleteWithLessonsConfig() {
		const { t, type } = this.props;
		const footer = <div>
			<Button bsStyle='primary' onClick={() => { this.deleteProgramItem(); this.setState({ showDeleteWithLessons: false }); }}>{t('Common_Yes')}</Button>
			<Button onClick={() => this.setState({ showDeleteWithLessons: false })}>{t('Common_No')}</Button>
		</div>;
		return {
			header: t('WeeklyProgram_DeleteConfirmationTitle'),
			body: t('WeeklyProgram_DeleteWarning'),
			onHide: () => this.setState({ showDeleteWithLessons: false }),
			footer: footer
		};
	}

	filter(weeklyProgram, status) {
		// Status is 1 for normal programs, 2 for trial programs, 4 for single classes
		return weeklyProgram.filter(program => program.status == status);
	}

	renderEditComponent() {
		const { weeklyPrograms, ...rest } = this.props;
		const data = this.filter(weeklyPrograms, 1);
		return (
			<EditWeeklyProgram
				onNew={this.handleNewClick}
				onEdit={this.handleEditClick}
				weeklyPrograms={data}
				{...rest}

			/>
		);
	}

	renderAddOneOffClassesComponent(status, header) {
		const { weeklyPrograms, ...rest } = this.props;
		const data = this.filter(weeklyPrograms, status);
		return (
			<OneOffProgram
				data={data}
				headerLabel={header}
				onNew={this.handleNewClick}
				onEdit={this.handleEditClick}
				mode={OneOffProgramMode.ADD}
				{...rest}
			/>
		);
	}

	renderCopyComponent() {
		const { centerId } = this.props;
		const initialValues = { centerId };
		return (
			<CopyWeeklyProgram
				onSubmit={this.handleCopy}
				initialValues={initialValues}
				{...this.props}
			/>
		);
	}

	renderAutoEnrolComponent() {
		return (
			<AutoEnrolProgram {...this.props} />
		);
	}

	render() {
		const { t, type } = this.props;

		let component;
		switch (type) {
			case types.EDIT:
				component = this.renderEditComponent();
				break;
			case types.TRIAL:
				component = this.renderAddOneOffClassesComponent(2, t('WeeklyProgram_TrialLessons'));
				break;
			case types.SINGLE:
				component = this.renderAddOneOffClassesComponent(4, t('WeeklyProgram_SingleLessons'));
				break;
			case types.COPY:
				component = this.renderCopyComponent();
				break;
			case types.AUTO_ENROL:
				component = this.renderAutoEnrolComponent();
				break;
		}

		const dialogConfig = this.dialogConfig();

		return (
			<div>
				<Dialog config={dialogConfig} show={this.state.showDialog} t={t} enforceFocus={false} />
				{component}
				<Dialog config={this.dialogDeleteWithLessonsConfig()} show={this.state.showDeleteWithLessons} t={t} />
			</div>
		);
	}
}

const mapStateToProps = (state, ownProps) => {
	const { centerId, termId, type } = queryString.parse(ownProps.location.search);

	const {
		entities: { weeklyPrograms, grades, centers, terms, teachers },
		filters: { teachersUnpagedByFranchisee },
		lookups: { singleLessonRecurrenceTypes, recurrenceDaysOfWeek },
		auth: { currentUser },
		configuration: { franchisor }
	} = state;
	const center = centers[centerId];
	const teachesFilter = center && teachersUnpagedByFranchisee[center.franchiseeId] || { ids: [] };

	return {
		type,
		centerId,
		termId,
		center: center,
		term: terms[termId],
		weeklyPrograms: filterPrograms(weeklyPrograms, centerId, termId),
		grades: Object.values(grades).filter(grade => !grade.centerId || grade.centerId == centerId),
		teachers: teachesFilter.ids ? teachesFilter.ids.map(id => teachers[id]) : [],
		terms,
		recurrenceTypes: singleLessonRecurrenceTypes,
		recurrenceDaysOfWeek,
		isReadonly: authUtils.hasReadOnlyPermission(currentUser, 'WeeklyPrograms'),
		enableTrials: franchisor.enableTrials,
		enableMakeUps: franchisor.enableMakeUps,
		enableAutoEnrolment: franchisor.enableAutoEnrolment,
		timetableViewType: franchisor.timetableViewType,
		frontOfficeUrl: franchisor.frontOfficeUrl,
		weeklyProgramFormValues: { recurrenceType: weeklyProgramFormSelector(state, 'recurrenceType'), useTermDefault: weeklyProgramFormSelector(state, 'useTermDefault'), useGradeDefault: weeklyProgramFormSelector(state, 'useGradeDefault') }
	};
};


const mapDispatchToProps = {
	fetchWeeklyProgram,
	createWeeklyProgram,
	updateWeeklyProgram,
	loadUnpagedWeeklyProgram,
	loadGrades: loadUnpagedGrades,
	fetchTerm,
	fetchCenter,
	copyWeeklyProgram,
	deleteWeeklyProgram,
	loadUnpagedTeachers,
	validateDelete
};

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(Details));